var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.attributes.type === "checkbox"
    ? _c(
        "input",
        _vm._g(
          _vm._b(
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.model,
                  expression: "model",
                },
              ],
              staticClass: "md-input",
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.model)
                  ? _vm._i(_vm.model, null) > -1
                  : _vm.model,
              },
              on: {
                focus: _vm.onFocus,
                blur: _vm.onBlur,
                change: function ($event) {
                  var $$a = _vm.model,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.model = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.model = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.model = $$c
                  }
                },
              },
            },
            "input",
            _vm.attributes,
            false
          ),
          _vm.listeners
        )
      )
    : _vm.attributes.type === "radio"
    ? _c(
        "input",
        _vm._g(
          _vm._b(
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.model,
                  expression: "model",
                },
              ],
              staticClass: "md-input",
              attrs: { type: "radio" },
              domProps: { checked: _vm._q(_vm.model, null) },
              on: {
                focus: _vm.onFocus,
                blur: _vm.onBlur,
                change: function ($event) {
                  _vm.model = null
                },
              },
            },
            "input",
            _vm.attributes,
            false
          ),
          _vm.listeners
        )
      )
    : _c(
        "input",
        _vm._g(
          _vm._b(
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.model,
                  expression: "model",
                },
              ],
              staticClass: "md-input",
              attrs: { type: _vm.attributes.type },
              domProps: { value: _vm.model },
              on: {
                focus: _vm.onFocus,
                blur: _vm.onBlur,
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.model = $event.target.value
                },
              },
            },
            "input",
            _vm.attributes,
            false
          ),
          _vm.listeners
        )
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }